import { useState, useEffect } from "react";
import { useUpdateNote } from "../../../../../../hooks/useUpdateNote";
import {
  Paper,
  TextField,
  Typography,
  IconButton,
  Grid,
  Modal,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import LoadingButton from "@mui/lab/LoadingButton";

const EditNoteModal = ({ token, open, close, note, refresh, idDocument }) => {
  const [title, setTitle] = useState("");
  const [sintesis, setSintesis] = useState("");

  useEffect(() => {
    if (open) {
      setTitle(note?.titulo || "");
      setSintesis(note?.sintesis || "");
    }
  }, [note, open]);

  const { updateNote, loading } = useUpdateNote(token);

  const handleSave = async () => {
    const success = await updateNote(note?.id_sintesis, title, sintesis);
    if (success) {
      close();
      refresh();
    }
  };

  return (
    <Modal open={open} onClose={close}>
      <Paper
        elevation={2}
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          padding: "20px",
          width: "70%",
          outline: "none",
        }}
      >
        <Grid
          container
          spacing={2}
          justifyContent="space-between"
          alignItems="center"
        >
          <Grid item xs={10}>
            <Typography variant="h6">Editar nota</Typography>
          </Grid>
          <Grid item xs={2} style={{ textAlign: "right" }}>
            <IconButton onClick={close}>
              <CloseIcon />
            </IconButton>
          </Grid>
        </Grid>

        <div>
          <Grid container spacing={3} style={{ marginTop: "10px" }}>
            <Grid item xs={12}>
              <TextField
                label="Título"
                name="titulo"
                variant="outlined"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                fullWidth
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Síntesis"
                variant="outlined"
                name="sintesis"
                value={sintesis}
                onChange={(e) => setSintesis(e.target.value)}
                fullWidth
                multiline
                minRows={8}
              />
            </Grid>
          </Grid>
          <Grid
            container
            justifyContent="flex-end"
            style={{ marginTop: "20px" }}
          >
            <Grid item>
              <LoadingButton
                variant="contained"
                color="primary"
                onClick={handleSave}
                loading={loading}
              >
                Aceptar
              </LoadingButton>
            </Grid>
          </Grid>
        </div>
      </Paper>
    </Modal>
  );
};

export default EditNoteModal;
